import { render, staticRenderFns } from "./LPLApp.vue?vue&type=template&id=3de5f84e"
import script from "./LPLApp.vue?vue&type=script&lang=js"
export * from "./LPLApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports